
import BaseTemplate from '../src/layouts/BaseTemplate'
import BookingPage from '../src/view/_public/BookingPage';



export default function Booking(props) {
  // const { data, status } = useQuery('users', getUsers, { initialData: props.users })
  // console.log("data", data)
  // console.log("status", status)
  // console.log("bookingprops", props)
  
  return (
    <BaseTemplate title="Booking" body={<BookingPage />} />
  )
}
